<template>
  <svg v-bind:class="['star-icon', starIconClass]" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 0.666656C8.25385 0.666656 8.48559 0.810705 8.59791 1.03824L10.5029 4.89763L14.7632 5.52033C15.0142 5.55703 15.2227 5.73303 15.3009 5.97437C15.3792 6.21571 15.3137 6.48054 15.1319 6.65756L12.0498 9.65957L12.7772 13.9006C12.8201 14.1508 12.7172 14.4035 12.5119 14.5527C12.3066 14.7018 12.0344 14.7215 11.8098 14.6034L8.0001 12.5999L4.1904 14.6034C3.96579 14.7215 3.6936 14.7018 3.48828 14.5527C3.28296 14.4035 3.18013 14.1508 3.22303 13.9006L3.95042 9.65957L0.868279 6.65756C0.686534 6.48054 0.621018 6.21571 0.69927 5.97437C0.777522 5.73303 0.985975 5.55703 1.23702 5.52033L5.49726 4.89763L7.4023 1.03824C7.51461 0.810705 7.74635 0.666656 8.0001 0.666656ZM8.0001 2.83949L6.53791 5.80174C6.44088 5.9983 6.25342 6.13461 6.03652 6.16631L2.76571 6.64439L5.13192 8.94909C5.28917 9.10225 5.36095 9.323 5.32384 9.53935L4.76555 12.7944L7.6898 11.2566C7.88406 11.1545 8.11615 11.1545 8.3104 11.2566L11.2346 12.7944L10.6764 9.53935C10.6393 9.323 10.711 9.10225 10.8683 8.94909L13.2345 6.64439L9.96368 6.16631C9.74678 6.13461 9.55932 5.9983 9.4623 5.80174L8.0001 2.83949Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'StarIcon',
  props: {
    starIconClass: String,
  }
};
</script>

<style lang="scss">

</style>
